import {TranslateService} from '@ngx-translate/core';

import {DashboardChartUtils} from './dashboard-chart.utils';

import {ChartUtils} from '../../+postpayroll/check/key-metrics/charts/chart.utils';
import {StackedBar} from '../../+postpayroll/check/key-metrics/charts/column/stacked-bar';
import {Chart} from '../../+postpayroll/check/key-metrics/key-metrics.interfaces';
import {LocalizationService} from '../../shared/localization/localization.service';
import {ChartBoxElement, DashboardBox, ResponseChartBox} from '../dashboard.interfaces';

export class TerminationReasonChart extends StackedBar {
  constructor(chartBox: ResponseChartBox,
              translate: TranslateService,
              localization: LocalizationService) {
    const params = chartBox.params;
    const chart: Chart = ChartUtils.getEmptyChart();
    let total: number = 0;

    Object.keys(params).forEach((key: string) => {
      if (!params[key].length) {
        chart.data.push({
          category: null,
          name: key,
          value: null
        });
      }

      params[key].forEach((element: ChartBoxElement) => {
        total += element.value;
        chart.data.push({
          category: element.name,
          name: key,
          value: element.value,
          metadata: element.link
        });
      });
    });
    chart.type = chartBox.cardType;

    super(chart, translate, localization, total);

    this.xAxis = [{
      axisLine: {
        show: true
      },
      axisTick: {
        show: true,
        alignWithLabel: true,
      }
    }];

    this.grid = DashboardChartUtils.getGridOptions();


    this.yAxis = [{
      axisLabel: DashboardChartUtils.getAxisOptions(),
      data: DashboardChartUtils.formatCategories(this.yAxis.data, translate),
      axisTick: {
        show: true,
      }
    }];

    this.legend = null;
    this.animation = true;
    this.tooltip.position = DashboardChartUtils.getTooltipPositionFunc(<DashboardBox>chartBox);
    DashboardChartUtils.setLinks(this.series, this.chart, this.categories);
    this.series.forEach((serie, index) => {
      serie.itemStyle = {
        normal: {
          barBorderRadius: 5,
          barBorderWidth: 1,
          label: {
            show: true,
            formatter: this.getLabelFormatter(),
          }
        }
      };
    });
    this.color = DashboardChartUtils.standardColors();
  }

  public sortCategories(array: string[]): string[] {
    return DashboardChartUtils.monthSort(array);
  }
}
